export default class DetailInfo {
    constructor(id, type, label, value) {
        this.id = id;
        this.type = type;
        this.label = label;
        this.value = value;
    }
}